module.exports = __webpack_public_path__ + "static/p14_ovejitas-369a65ace5b7c52fde0425dd0eb84363.png";